import styled from "styled-components";
import { User } from "../../types/model";

const Wrapper = styled.div`
  margin: var(--space-200) 0 var(--space-100);
  p {
    margin-bottom: 0;
  }
  ${({ theme }) => `${theme.breakpoints.lg} {
    margin: var(--space-250) 0 var(--space-200);
  }`}
`;

const UserDetails = ({ user }: { user: User }) => {
  const contactInfo = Object.values(user.contact);
  return (
    <Wrapper>
      <p>
        {user.firstName} {user.lastName}
      </p>
      {contactInfo.map((info, i) => (
        <p key={i}>{info}</p>
      ))}
    </Wrapper>
  );
};

export default UserDetails;
